import { createSlice } from "@reduxjs/toolkit";

// Define the initial state of the modal
//
// `note` and `confirmLabel` are OPTIONAL and default-preserving: every existing
// caller dispatches openModal({ title, subtitle, onConfirm }) and gets exactly
// the previous copy ("This action cannot be undone." + a "Confirm" button).
// They exist because not every confirmable action is a destructive, permanent
// delete -- detaching a capture from a Wheel is reversible (the item stays in
// the Capture inbox and can be re-attached), so telling the user it "cannot be
// undone" would be a lie printed by a shared component.
const initialState = {
  isOpen: false,
  title: "",
  subtitle: "",
  note: undefined,
  confirmLabel: undefined,
  cancelLabel: undefined,
  onCancel: () => {},
  onConfirm: () => {},
};

const deleteDialogSlice = createSlice({
  name: "deleteDialog",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.subtitle = action.payload.subtitle;
      // Assigned unconditionally (not `??=`) so a previous dialog's custom note
      // or button label can never bleed into the next one that omits them.
      state.note = action.payload.note;
      state.confirmLabel = action.payload.confirmLabel;
      state.cancelLabel = action.payload.cancelLabel;
      state.onCancel = action.payload.onCancel;
      state.onConfirm = action.payload.onConfirm;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.onCancel = () => {};
      state.onConfirm = () => {};
    },
  },
});

export const { openModal, closeModal } = deleteDialogSlice.actions;

export default deleteDialogSlice.reducer;
